import { ROSTER_GRID_TEMPLATE, ROSTER_GRID_GAP, ROSTER_ROW_PAD_X } from '../../lib/roster-format'

/**
 * Column header for the roster, sharing ROSTER_GRID_TEMPLATE with every
 * RosterRow so the labels sit directly above their columns. Purely
 * presentational (no interactive content) — screen readers get the labels via
 * the visible text; the rows themselves carry their own accessible names.
 */
export function RosterHeader(): JSX.Element {
  const labelStyle: React.CSSProperties = {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: 'var(--text-3)',
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }
  return (
    <div
      aria-hidden="true"
      style={{
        display: 'grid',
        gridTemplateColumns: ROSTER_GRID_TEMPLATE,
        columnGap: ROSTER_GRID_GAP,
        // +1px for the rows' card border so labels align with row content.
        padding: `0 ${ROSTER_ROW_PAD_X + 1}px 4px`,
      }}
    >
      <span style={labelStyle}>Person</span>
      <span style={labelStyle}>Team</span>
      <span style={labelStyle}>Next leave</span>
    </div>
  )
}
